import {
  // APPLICATION_SAVE_ASSIGNMENT,
  CANCEL_OFFER,
  CLOSE_APPLICATION_SNACKBAR,
  COMPLETE_OFFER_FORM,
  EDIT_ASSIGNMENT,
  FILTER_APPLICANTS,
  GET_APPLICANT_DETAILS_SUCCESS,
  GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS,
  GET_TOTAL_APPLICATIONS_SUCCESS,
  LOCATION_CHANGE,
  OFFER_ASSIGNMENT,
  PREVIEW_ASSIGNMENT_SUCCESS,
  REJECT_APPLICATION_SUCCESS,
  REJECT_WARNING,
  SELECTED_APPLICANT,
  SIGN_ASSIGNMENT_PAD,
  SIGN_SEND_CONTRACT_FAILED,
  SIGN_SEND_CONTRACT_SUCCESS,
  CLOSE_SIGN_CONTRACT_SCREEN,
  APPLICATION_PAGE_CHANGE,
  PREVIEW_ASSIGNMENT_FAILED
} from '../../constants/employer'

const initialState = {
  applications: [],
  selectedRows: [],
  applicationDetails: [],
  filterApplicants: [],
  isFilter: false,
  totalCount: [],
  isOffer: false,
  offerToPerson: [],
  isCompleteForm: false,
  formValues: [], // Offer form value
  showPdfDialog: false, // Click Save to show the PDF dialog
  enableSendOrSignButton: false,
  signPad: false,
  showRejectWarning: false,
  filterJobID: '',
  showSnackbar: false,
  showFailedSnackbar: false,
  offeredFromLightEntre: [],
  isEditAssignment: false,
  selectedOfferedData: [],
  selected: 0,
  pageSize: 10,
  isSigned: false,
  directlyOfferData: []
}

const applicationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLICATION_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selected: action.selected.selected
        }
      )
    case GET_APPLICANT_DETAILS_SUCCESS:
      const data = mergeRecords(action.data)
      // console.log('huong get applicant data', data)

      // Jobs list
      // const jobsList = data.map(
      //   ({
      //     job_title,
      //     industry_type,
      //     location,
      //     assignment_type,
      //     last_date_of_application,
      //     salary_model,
      //     assignment_begins,
      //     enterpreneur_email,
      //     industry,
      //     applied_job_id
      //   }) => ({
      //     job_title,
      //     industry_type,
      //     location,
      //     assignment_type,
      //     last_date_of_application,
      //     salary_model,
      //     assignment_begins,
      //     enterpreneur_email,
      //     industry,
      //     applied_job_id
      //   })
      // )
      // console.log('huong job list', jobsList)

      // Application job with review status is no
      // const jobNotReview = data.filter(
      //   (el) => el.isapplication_reviewed === 'no'
      // )
      // console.log('huong job not review', jobNotReview)

      // Application job id count with review status is no
      // Application with no review status is new application
      // isapplication_reviewed
      // let newApplicationCount = getAppliedJobIdCount(jobNotReview)
      // newApplicationCount = newApplicationCount.map((item) => {
      //   return {
      //     applied_job_id: item.applied_job_id,
      //     totalNewApplication: item.count
      //   }
      // })
      // console.log('huong new job count by app id', newApplicationCount)

      // applied_job_id count
      // const appliedJobIdCount = getAppliedJobIdCount(jobsList)
      // console.log('huong applied_job_id count', appliedJobIdCount)

      // Unique jobs list
      // const uniqueJobsList = Array.from(
      //   new Set(jobsList.map((obj) => objectToString(obj)))
      // ).map((str) => JSON.parse(str))
      // console.log('huong unique jobs list', uniqueJobsList)

      // Update unique jobs list with count of app and total new app
      // const updateUniqueJobsList = addCountToUniqueJobsList(
      //   uniqueJobsList,
      //   appliedJobIdCount,
      //   newApplicationCount
      // )
      // console.log('huong updateUniqueJobsList', updateUniqueJobsList)
      return Object.assign(
        {},
        { ...state },
        {
          applications: action.data,
          applicationDetails: data
        }
      )
    case GET_TOTAL_APPLICATIONS_SUCCESS:
      // console.log('huong total count', action.data)
      return Object.assign(
        {},
        { ...state },
        {
          totalCount: JSON.parse(action.data)
        }
      )
    case GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          offeredFromLightEntre: action.data,
          directlyOfferData: action.directlyOfferData
        }
      )
    case FILTER_APPLICANTS:
      const appJobID = action.appJobID
      // console.log('huongggggggg', appJobID)
      const applicationDetails = state.applicationDetails
      const filterApplicants = applicationDetails.filter(
        (el) => el.applied_job_id === appJobID
      )
      // console.log('huongggggggg', filterApplicants)
      return Object.assign(
        {},
        { ...state },
        {
          isFilter: true,
          filterApplicants: filterApplicants,
          filterJobID: appJobID
        }
      )
    case REJECT_WARNING:
      return Object.assign(
        {},
        { ...state },
        {
          showRejectWarning: true
        }
      )
    case REJECT_APPLICATION_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showRejectWarning: false
        }
      )
    case OFFER_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          isOffer: true,
          offerToPerson: action.selected,
          showPdfDialog: false
        }
      )
    case COMPLETE_OFFER_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          isCompleteForm: true,
          isOffer: false
        }
      )
    // case APPLICATION_SAVE_ASSIGNMENT:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       formValues: action.formValues,
    //       showPdfDialog: true
    //       // isCompleteForm: false,
    //       // isEditAssignment: false
    //     }
    // )
    case EDIT_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          showPdfDialog: false,
          isCompleteForm: true,
          enableSendOrSignButton: false,
          isEditAssignment: true
        }
      )
    case PREVIEW_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          enableSendOrSignButton: true,
          formValues: action.data
        }
      )
    case PREVIEW_ASSIGNMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          enableSendOrSignButton: false
        }
      )
    case SIGN_ASSIGNMENT_PAD:
      return Object.assign(
        {},
        { ...state },
        {
          signPad: true,
          selectedOfferedData: action.selectedOfferedData
        }
      )
    case CLOSE_SIGN_CONTRACT_SCREEN:
      return Object.assign(
        {},
        { ...state },
        {
          signPad: false
        }
      )
    case SIGN_SEND_CONTRACT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          signPad: false,
          enableSendOrSignButton: false,
          showSnackbar: true,
          showFailedSnackbar: false,
          showPdfDialog: false,
          isEditAssignment: false,
          isCompleteForm: false,
          isSigned: action.isSigned,
          previewFormValues: []
        }
      )
    case SIGN_SEND_CONTRACT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailedSnackbar: true,
          showSnackbar: false,
          isSigned: action.isSigned
        }
      )
    case CLOSE_APPLICATION_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: false,
          isSigned: false
        }
      )
    case CANCEL_OFFER:
      return Object.assign(
        {},
        { ...state },
        {
          isOffer: false,
          offerToPerson: [],
          isCompleteForm: false,
          showPdfDialog: false,
          enableSendOrSignButton: false,
          signPad: false,
          showRejectWarning: false
        }
      )
    case SELECTED_APPLICANT:
      return Object.assign(
        {},
        { ...state },
        {
          selectedRows: _handleApplicantRowClick(
            action.selected,
            state.selectedRows
          )
        }
      )
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selectedRows: [],
          isFilter: false,
          filterJobID: '',
          isOffer: false,
          isCompleteForm: false,
          showPdfDialog: false,
          signPad: false,
          showSnackbar: false,
          showFailedSnackbar: false,
          selected: 0,
          isSigned: false
        }
      )
    default:
      return state
  }
}

// Function to combine application with same application_id and applied_job_id into 1 record
// Data returned from APIs is split record base on experiences at Open for work profile
// So need to merge record with the same application_id and applied_job_id
function mergeRecords(data) {
  const mergedRecords = {}

  data.forEach((record) => {
    const key = `${record.application_id}-${record.applied_job_id}`

    if (!mergedRecords[key]) {
      mergedRecords[key] = { ...record, experiences: [] }
    }

    const experience = {
      CompanyName: record.CompanyName,
      JobTitle: record.JobTitle,
      Location: record.Location,
      StartDate: record.StartDate,
      EndDate: record.EndDate,
      Responsibilities: record.Responsibilities,
      KeyAchievements: record.KeyAchievements
    }

    mergedRecords[key].experiences.push(experience)
  })

  // Remove the properties that have been added to experience
  const result = Object.values(mergedRecords).map((record) => {
    const {
      CompanyName,
      JobTitle,
      Location,
      StartDate,
      EndDate,
      Responsibilities,
      KeyAchievements,
      ...rest
    } = record
    console.log(
      CompanyName,
      JobTitle,
      Location,
      StartDate,
      EndDate,
      Responsibilities,
      KeyAchievements
    )
    return {
      ...rest,
      experiences: record.experiences
    }
  })

  return result
}

// Function to convert a dictionary to a hashable string
// function objectToString(obj) {
//   return JSON.stringify(obj)
// }

// Function to get the count of each applied_job_id
// function getAppliedJobIdCount(data) {
//   const countMap = new Map()

//   data.forEach((obj) => {
//     const key = objectToString({ applied_job_id: obj.applied_job_id })
//     countMap.set(key, (countMap.get(key) || 0) + 1)
//   })

//   const appliedJobIdCount = []
//   countMap.forEach((count, key) => {
//     const appliedJobIdObj = JSON.parse(key)
//     appliedJobIdObj.count = count
//     appliedJobIdCount.push(appliedJobIdObj)
//   })

//   return appliedJobIdCount
// }

// Function to add count key to the unique jobs list
// function addCountToUniqueJobsList(
//   uniqueJobsList,
//   appliedJobIdCount,
//   newApplicationCount
// ) {
//   const firstObjectMap = new Map()
//   const secondObjectMap = new Map()

//   appliedJobIdCount.forEach((obj) => {
//     firstObjectMap.set(obj.applied_job_id, obj.count)
//   })
//   newApplicationCount.forEach((obj) => {
//     secondObjectMap.set(obj.applied_job_id, obj.totalNewApplication)
//   })

//   return uniqueJobsList.map((obj) => {
//     const count = firstObjectMap.get(obj.applied_job_id)
//     const totalNewApplication = secondObjectMap.get(obj.applied_job_id)
//     return { ...obj, count, totalNewApplication }
//   })
// }

const _handleApplicantRowClick = (id, selectedRows) => {
  let applicantRowSelected = selectedRows
  let selectedIndex = applicantRowSelected.indexOf(id)

  let newSelected = []

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(applicantRowSelected, id)
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(applicantRowSelected.slice(1))
  } else if (selectedIndex === applicantRowSelected.length - 1) {
    newSelected = newSelected.concat(applicantRowSelected.slice(0, -1))
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      applicantRowSelected.slice(0, selectedIndex),
      applicantRowSelected.slice(selectedIndex + 1)
    )
  }

  applicantRowSelected = newSelected
  return applicantRowSelected
}

export default applicationsReducer
